import styled from "styled-components";

import {
  subMenuDropdownBackground
} from '../../config/colors';

export const RemainingEngineeringScopeWrapper = styled.div`
    display: flex;
    flex-grow: 1;
    flex-direction: column;
    background-color: ${subMenuDropdownBackground};
    padding: 35px 25px 100px 35px;

    @media print {
      background-color: inherit;
    }
`;


